import {ElementRef, Injectable} from '@angular/core';

@Injectable()
export class SnackBarHandlerService {
	snackbar: ElementRef;

	constructor() { }

	showSnackbar(msg: string, timeout: number) {
		this.snackbar.nativeElement.className = 'show';
		this.snackbar.nativeElement.innerText = msg;
		setTimeout(() => this.hideSnackbar(), timeout);
	}

	setSnackbar(el: ElementRef) {
		this.snackbar = el;
	}

	hideSnackbar() {
		this.snackbar.nativeElement.className = '';
	}

}
